module.exports = __webpack_public_path__ + "Flama-Light.woff2?1069d3857b916a4f5c51fdb73ad9bdc5";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Light.woff2
// module id = 929
// module chunks = 0